const FormatPhoneNumber = (number) => {
    // Chỉ giữ lại các chữ số, loại bỏ tất cả ký tự không phải số
    const digits = number?.replace(/\D/g, '');

    // Xử lý trường hợp không có dữ liệu nhập vào
    if (!digits) return '';

    // Phân loại và định dạng dựa trên mã vùng và độ dài số điện thoại
    if (digits.startsWith('02')) { // Mã vùng Seoul (02)
        if (digits.length <= 3) {
            return digits; // Chưa đủ số để định dạng
        } else if (digits.length <= 6) {
            // Định dạng: 02-XXXX
            return `${digits.substring(0, 2)}-${digits.substring(2)}`;
        } else {
            // Định dạng đầy đủ: 02-XXXX-XXXX
            return `${digits.substring(0, 2)}-${digits.substring(2, 6)}-${digits.substring(6, 10)}`;
        }
    } else if (digits.startsWith('01')) { // Số điện thoại di động (010, 011,...)
        if (digits.length <= 3) {
            return digits; // Chưa đủ số để định dạng
        } else if (digits.length <= 7) {
            // Định dạng: 010-XXXX
            return `${digits.substring(0, 3)}-${digits.substring(3)}`;
        } else {
            // Định dạng đầy đủ: 010-XXXX-XXXX
            return `${digits.substring(0, 3)}-${digits.substring(3, 7)}-${digits.substring(7, 11)}`;
        }
    } else if (digits.length >= 2 && digits.charAt(0) === '0') { // Các mã vùng khác
        if (digits.length <= 4) { // Mới chỉ nhập mã vùng
            return digits;
        } else if (digits.length <= 7) { // Mã vùng + một phần số
            // Trường hợp mã vùng 3 chữ số (031, 032,...)
            if (digits.charAt(1) !== '0') {
                return `${digits.substring(0, 3)}-${digits.substring(3)}`;
            }
            // Trường hợp mã vùng 4 chữ số (0505,...)
            else {
                return `${digits.substring(0, 4)}-${digits.substring(4)}`;
            }
        } else { // Số điện thoại đầy đủ
            // Xử lý cho mã vùng 3 chữ số
            if (digits.charAt(1) !== '0') {
                return `${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
            }
            // Xử lý cho mã vùng 4 chữ số
            else {
                return `${digits.substring(0, 4)}-${digits.substring(4, 8)}-${digits.substring(8, 12)}`;
            }
        }
    } else { // Các số điện thoại thông thường hoặc trường hợp khác
        // Số điện thoại 8 chữ số (không có mã vùng)
        if (digits.length === 8) {
            return `${digits.substring(0, 4)}-${digits.substring(4)}`;
        } else {
            return digits; // Trả về nguyên dạng nếu không khớp với bất kỳ mẫu nào
        }
    }
};

export default FormatPhoneNumber